import React from 'react';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
const comparisons = [{
  feature: 'Enfoque',
  other: 'Templates genéricos para cualquier negocio',
  us: 'Construido exclusivamente para contractors'
}, {
  feature: 'Estrategia',
  other: 'Solo enfocado en diseño',
  us: 'Diseño + estrategia de conversión'
}, {
  feature: 'Precio',
  other: 'Mensualidades costosas obligatorias',
  us: 'Un solo pago de $250, sin mensualidades forzadas'
}, {
  feature: 'Tiempo',
  other: 'Semanas o meses para lanzar',
  us: 'Listo en menos de 72 horas'
}, {
  feature: 'Visibilidad',
  other: 'Sin estrategia de SEO',
  us: 'SEO local incluido desde el primer día'
}, {
  feature: 'Soporte',
  other: 'Sin soporte después del lanzamiento',
  us: 'Mantenimiento opcional disponible'
}, {
  feature: 'Resultados',
  other: 'Se ve bien pero no convierte',
  us: 'Construido para convertir visitas en llamadas'
}];
export function MechanismSection() {
  return <section className="py-24 bg-dark-100 relative overflow-hidden" data-id="element-207">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-208"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-16" data-id="element-210">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-211">
            <Zap className="w-4 h-4 text-gold mr-2" data-id="element-212" />
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-213">
              La Solución
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-214">
            Presentamos The Professional Presence System
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-215">
            La solución digital completa creada exclusivamente para contractors
            locales que quieren verse tan profesionales como trabajan — por un
            solo pago accesible y sin complicaciones.
          </p>
        </div>

        <div className="bg-dark rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-216">
          <div className="grid grid-cols-3 bg-dark-200 border-b border-white/10 p-6" data-id="element-217">
            <div className="col-span-1 font-bold text-gray-400 uppercase text-sm tracking-wider" data-id="element-218">
              Característica
            </div>
            <div className="col-span-1 font-bold text-gray-500 uppercase text-sm tracking-wider text-center" data-id="element-219">
              Otras Opciones
            </div>
            <div className="col-span-1 font-bold text-gold uppercase text-sm tracking-wider text-center" data-id="element-220">
              AS Elite Contractor
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-221">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-6 items-center hover:bg-white/[0.02] transition-colors" data-id="element-222">
                <div className="col-span-1 text-sm md:text-base font-medium text-gray-300 pr-4" data-id="element-223">
                  {item.feature}
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-224">
                  <XCircle className="w-5 h-5 text-red-500/50 mb-2" data-id="element-225" />
                  <span className="text-sm text-gray-500" data-id="element-226">{item.other}</span>
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-227">
                  <CheckCircle2 className="w-6 h-6 text-gold mb-2" data-id="element-228" />
                  <span className="text-sm font-bold text-white" data-id="element-229">
                    {item.us}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}